/**
 * An enum used for the condition diagnosis entity to describe where/who the diagnosis come from.
 * The enum is also used to describe how "certain/precise" the diagnosis is.
 *
 *  1. Tentative -> It's from the general practitioner. It's valued as a "guess" and is the lowest form of certainty.
 *  2. Specialty -> It's from the dermatologist (Both tele- and physical-referral). It's a high form of certainty (Silver standard - meme).
 *  3. Histopathological -> It's from the pathologist (Given after biopsy). It's the highest form of certainty (Gold standard).
 */
export enum DiagnosisCertaintyTypeEnum {
  Tentative = 'tentative',
  Specialty = 'specialty',
  Histopathological = 'histopathological',
}

/**
 * An enum used for the condition diagnosis entity to describe how the diagnosis was entered.
 *
 * The diagnosis came from a pathologist or dermatologist that's:
 *  1. Manual -> NOT on dermloop and the user entered the given diagnosis manually in the app.
 *  2. Dermloop -> on dermloop and it's entered by the pathologist/dermatologist self through the app.
 */
export enum DiagnosisSourceEnum {
  Manual = 'manual',
  Dermloop = 'dermloop',
}
